<template>
        <div class="d-flex flex-wrap p-0 m-0 col-xs-12 col-lg-10 col-xl-8 mb-3">

            <form-field :label="getFieldLabel('actNumber')"
                        class="col-xs-12 col-sm-3 p-0 mr-0 mr-sm-3 mb-3"
                        :value="object.actNumber"
                        :editable="isEditable('actNumber')"
                        :feedback="liveFeedback('actNumber')">
                <template #field>
                        <b-input
                            id="actNumber"
                            class="w-100"
                            placeholder="№"
                             v-model="$v.form.actNumber.$model"
                            :state="validateState('actNumber')">
                        </b-input>
                </template>
            </form-field>

            <date-time-picker class="col-xs-12 col-sm-6 col-md-4 mr-0 mr-sm-3 mb-2 p-0"
                      ref="actDate"
                      :title="getFieldLabel('actDate')"
                      name="actDate"
                      :editable="isEditable('actDate')"
                      :show-timepicker="false"
                      :date-required="false"
                      :key="getActDate() + '-a'"
                      :initial-date-string="getActDate()"
                      :state="validateState('actDate')"
                      @date-changed="onModelDateChanged" />

            <date-time-picker class="col-xs-12 col-sm-6 col-md-4 mr-0 mr-sm-3 mb-2 p-0"
                              ref="deathDate"
                              :title="getFieldLabel('deathDate')"
                              name="deathDate"
                              :editable="isEditable('deathDate')"
                              :show-timepicker="false"
                              :date-required="false"
                              :key="getDeathDate() + '-d'"
                              :initial-date-string="getDeathDate()"
                              :state="validateState('deathDate')"
                              @date-changed="onModelDateChanged" />


            <form-field :label="getFieldLabel('circumstances')"
                        class="col-xs-12 col-sm-12 col-md-8 p-0 mr-0 mr-sm-3 mb-3"
                        :value="object.circumstances"
                        :editable="isEditable('circumstances')"
                        :feedback="liveFeedback('circumstances')">
                <template #field>
                        <b-textarea
                            id="circumstances"
                            v-model="$v.form.circumstances.$model"
                            :state="validateState('circumstances')">
                        </b-textarea>
                </template>
            </form-field>

            <form-field :label="getFieldLabel('executorPosition')"
                        class="col-xs-12 col-md-8 p-0 mr-0 mr-sm-3 mb-2"
                        :value="object.executorPosition"
                        :editable="isEditable('executorPosition')"
                        :feedback="liveFeedback('executorPosition')">
                <template #field>
                        <b-input type="text"
                            id="executorPosition"
                            v-model="$v.form.executorPosition.$model"
                            :state="validateState('executorPosition')">
                        </b-input>
                </template>
            </form-field>

            <date-time-picker class="col-xs-12 col-sm-6 col-md-4 col-lg-4 mr-0 mr-sm-3 mb-2 p-0"
                  ref="supportingDocumentDate"
                  :title="getFieldLabel('supportingDocumentDate')"
                  name="supportingDocumentDate"
                  :editable="isEditable('supportingDocumentDate')"
                  :show-timepicker="false"
                  :date-required="false"
                  :key="getSupportingDocumentDate() + '-s'"
                  :initial-date-string="getSupportingDocumentDate()"
                  :state="validateState('supportingDocumentDate')"
                  @date-changed="onModelDateChanged" />

            <form-field :label="getFieldLabel('supportingDocumentNumber')"
                        class="col-xs-12 col-sm-6 col-md-8 col-lg-6 p-0 mr-0 mr-sm-3 mb-2"
                        :value="object.supportingDocumentNumber"
                        :editable="isEditable('supportingDocumentNumber')"
                        :feedback="liveFeedback('supportingDocumentNumber')">
                <template #field>
                        <b-input type="text"
                            id="supportingDocumentNumber"
                            v-model="$v.form.supportingDocumentNumber.$model"
                            :state="validateState('supportingDocumentNumber')">
                        </b-input>
                </template>
            </form-field>

            <form-field :label="getFieldLabel('wasteDisposalOrganizationName')"
                        class="col-xs-12 col-md-8 p-0 mr-0 mr-sm-3 mb-2"
                        :value="object.wasteDisposalOrganizationName"
                        :editable="isEditable('wasteDisposalOrganizationName')"
                        :feedback="liveFeedback('wasteDisposalOrganizationName')">
                <template #field>
                        <b-input type="text"
                            id="wasteDisposalOrganizationName"
                            v-model="$v.form.wasteDisposalOrganizationName.$model"
                            :state="validateState('wasteDisposalOrganizationName')">
                        </b-input>
                </template>
            </form-field>


        </div>
</template>

<script>
    import FormField from "../../../../components/Forms/FormField";
    import DateTimePicker from "../../../../components/Forms/DateTimePicker";
    import {ObjectComponentMixin} from "../../../../components/Forms/ObjectComponentMixin";
    import {todayStr} from "../../../../utils/dateFormat";
    import {DeathEventAttributes} from "./death";
    import DownloadButton from "../../../../components/Files/DownloadButton";
    import {AttributeMixin} from "@/pages/AppPages/Events/AttributeMixin";
    import {mapGetters} from "vuex";

    export default {
        name: "DeathAttributes",
        components: { FormField, DateTimePicker, DownloadButton },
        mixins: [ObjectComponentMixin, AttributeMixin],
        computed: {
            ...mapGetters(['userPosition'])
        },
        methods: {
            getDeathDate() {
                return this.object.deathDate;
            },
            getActDate() {
                return this.object.actDate;
            },
            getSupportingDocumentDate() {
                return this.object.supportingDocumentDate;
            }
        },
        beforeMount() {
            this.objectClass = DeathEventAttributes;
            this.initialize();
            this.initObjectParams['deathDate'] = todayStr();
            this.initObjectParams['actDate'] = todayStr();
            this.initObjectParams['supportingDocumentDate'] = todayStr();
            this.initObjectParams['executorPosition'] = this.userPosition;
        },
        mounted() {
            this.onMount();
            this.resetForm();
        },
    }
</script>

<style scoped>

</style>